import { LocalizedText, lt, useFeatureFlag } from '@mews/framework';
import { TextKey, FeatureFlag } from '@mews-commander/enums';
import { IconName } from '@optimus-web/core';
import { PaymentRequestTableRecord } from '@mews-commander/data-access';
import { WithAccountId } from '@mews-commander/types';
import { useDialogForm } from '@mews-commander/form';
import { isPaymentRequestUnresolved } from '../../../utils';
import { PaymentRequestLinkDialogContent } from '../../forms/PaymentRequestLink/PaymentRequestLinkDialogContent';
import { PaymentsTablesActionsMenu } from '../PaymentsTablesActionsMenu';
import { useCancelPaymentRequest } from './hooks';

export const PaymentRequestActionsMenu = ({
    accountId,
    paymentRequest,
    isCompany = false,
}: { paymentRequest: PaymentRequestTableRecord; isCompany: boolean } & WithAccountId) => {
    const reservationLinkToPaymentsEnabled = useFeatureFlag(FeatureFlag.reservationLinkToPaymentsEnabled);

    const [renderChangeReservationLinkDialog, toggleChangeReservationLinkDialog] = useDialogForm({
        title: <LocalizedText textKey={TextKey.ChangeReservationLink} />,
        renderForm: (props) => (
            <PaymentRequestLinkDialogContent {...props} paymentRequestId={paymentRequest.id} accountId={accountId} />
        ),
    });

    const { mutate } = useCancelPaymentRequest({ accountId, paymentRequest });
    const handlePaymentRequestCancel = () => mutate({ accountId, paymentRequestId: paymentRequest.id });

    const cancelAction = {
        key: 'cancelPaymentRequestAction',
        onClick: handlePaymentRequestCancel,
        icon: IconName.CrossClose,
        text: lt('Cancel'),
    };

    const linkAction = {
        key: 'paymentRelinkAction',
        onClick: toggleChangeReservationLinkDialog,
        text: lt('ChangeReservationLink'),
        icon: IconName.ReservationProperties,
    };

    const actions = [
        ...(isPaymentRequestUnresolved(paymentRequest.state) ? [cancelAction] : []),
        ...(reservationLinkToPaymentsEnabled && !isCompany ? [linkAction] : []),
    ];

    if (actions.length === 0) {
        return null;
    }

    return (
        <>
            <PaymentsTablesActionsMenu actions={actions} />
            {renderChangeReservationLinkDialog()}
        </>
    );
};
